import { Logger } from "@remix-pwa/sw";
import { GameData } from "~/types/game";

const logger = new Logger({
  prefix: "[FetchGameDataClient]",
});

export const fetchGameData = async () => {
  try {
    const response = await fetch("/api/game"); // Call your API route

    if (!response.ok) {
      throw new Error(
        `Failed to fetch game data: ${response.status} ${await response.text()}`
      );
    }

    const data = await response.json();

    if (!data) {
      return null;
    }

    return data as GameData; // Contains { skills, userStats }
  } catch (error) {
    logger.error("Error fetching game data:", error);
    return null; // Handle error gracefully in UI
  }
};
